// Package billing.v3 defines the protocol buffer messages for billing portal management
// within the platform. This includes customer self-service portal sessions that allow
// customers to manage their billing information, subscriptions, and payment methods.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file billing/v3/portal.proto (package billing.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file billing/v3/portal.proto.
 */
export const file_billing_v3_portal: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common, file_google_protobuf_timestamp]);

/**
 * PortalAfterCompletion configures what happens after a customer completes
 * a specific flow in the portal, such as where to redirect them.
 *
 * @generated from message billing.v3.PortalAfterCompletion
 */
export type PortalAfterCompletion = Message<"billing.v3.PortalAfterCompletion"> & {
  /**
   * Type specifies the action to take after completion
   *
   * @generated from field: billing.v3.PortalAfterCompletionType type = 1;
   */
  type: PortalAfterCompletionType;

  /**
   * RedirectURL is where to redirect the customer after completion (required for redirect type)
   *
   * @generated from field: optional string redirect_url = 2;
   */
  redirectUrl: string;
};

/**
 * Describes the message billing.v3.PortalAfterCompletion.
 * Use `create(PortalAfterCompletionSchema)` to create a new message.
 */
export const PortalAfterCompletionSchema: GenMessage<PortalAfterCompletion> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 0);

/**
 * PortalRetentionSettings configures retention offers that are shown to customers
 * during subscription cancellation flows in the portal.
 *
 * @generated from message billing.v3.PortalRetentionSettings
 */
export type PortalRetentionSettings = Message<"billing.v3.PortalRetentionSettings"> & {
  /**
   * Enabled determines whether retention offers are shown during cancellation
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message billing.v3.PortalRetentionSettings.
 * Use `create(PortalRetentionSettingsSchema)` to create a new message.
 */
export const PortalRetentionSettingsSchema: GenMessage<PortalRetentionSettings> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 1);

/**
 * PortalSubscriptionCancel configures the subscription cancellation flow
 * in the customer portal, including which subscription to cancel and retention settings.
 *
 * @generated from message billing.v3.PortalSubscriptionCancel
 */
export type PortalSubscriptionCancel = Message<"billing.v3.PortalSubscriptionCancel"> & {
  /**
   * SubscriptionID is the ID of the subscription to cancel
   *
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;

  /**
   * Retention configures retention offers shown during cancellation
   *
   * @generated from field: optional billing.v3.PortalRetentionSettings retention = 2;
   */
  retention: PortalRetentionSettings;
};

/**
 * Describes the message billing.v3.PortalSubscriptionCancel.
 * Use `create(PortalSubscriptionCancelSchema)` to create a new message.
 */
export const PortalSubscriptionCancelSchema: GenMessage<PortalSubscriptionCancel> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 2);

/**
 * PortalSubscriptionUpdate configures the subscription update flow
 * in the customer portal for modifying an existing subscription.
 *
 * @generated from message billing.v3.PortalSubscriptionUpdate
 */
export type PortalSubscriptionUpdate = Message<"billing.v3.PortalSubscriptionUpdate"> & {
  /**
   * SubscriptionID is the ID of the subscription to update
   *
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;
};

/**
 * Describes the message billing.v3.PortalSubscriptionUpdate.
 * Use `create(PortalSubscriptionUpdateSchema)` to create a new message.
 */
export const PortalSubscriptionUpdateSchema: GenMessage<PortalSubscriptionUpdate> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 3);

/**
 * PortalDiscount represents a discount that can be applied in portal flows.
 * Only one of coupon_id or promotion_code_id should be specified.
 *
 * @generated from message billing.v3.PortalDiscount
 */
export type PortalDiscount = Message<"billing.v3.PortalDiscount"> & {
  /**
   * CouponID is the ID of a coupon to apply
   *
   * @generated from field: optional string coupon_id = 1;
   */
  couponId: string;

  /**
   * PromotionCodeID is the ID of a promotion code to apply
   *
   * @generated from field: optional string promotion_code_id = 2;
   */
  promotionCodeId: string;
};

/**
 * Describes the message billing.v3.PortalDiscount.
 * Use `create(PortalDiscountSchema)` to create a new message.
 */
export const PortalDiscountSchema: GenMessage<PortalDiscount> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 4);

/**
 * PortalSubscriptionItem represents a subscription item in portal flows.
 * This is used when pre-configuring subscription changes in the portal.
 *
 * @generated from message billing.v3.PortalSubscriptionItem
 */
export type PortalSubscriptionItem = Message<"billing.v3.PortalSubscriptionItem"> & {
  /**
   * ID is the subscription item ID (for existing items)
   *
   * @generated from field: optional string id = 1;
   */
  id: string;

  /**
   * PriceID is the ID of the price/plan for this item
   *
   * @generated from field: optional string price_id = 2;
   */
  priceId: string;

  /**
   * Quantity is the quantity for this subscription item
   *
   * @generated from field: optional int64 quantity = 3;
   */
  quantity: bigint;
};

/**
 * Describes the message billing.v3.PortalSubscriptionItem.
 * Use `create(PortalSubscriptionItemSchema)` to create a new message.
 */
export const PortalSubscriptionItemSchema: GenMessage<PortalSubscriptionItem> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 5);

/**
 * PortalSubscriptionUpdateConfirm configures the subscription update confirmation flow.
 * This allows you to pre-populate specific changes that the customer can confirm.
 *
 * @generated from message billing.v3.PortalSubscriptionUpdateConfirm
 */
export type PortalSubscriptionUpdateConfirm = Message<"billing.v3.PortalSubscriptionUpdateConfirm"> & {
  /**
   * SubscriptionID is the ID of the subscription to update
   *
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;

  /**
   * Items contains the subscription items to update
   *
   * @generated from field: repeated billing.v3.PortalSubscriptionItem items = 2;
   */
  items: PortalSubscriptionItem[];

  /**
   * Discounts contains discounts to apply during the update
   *
   * @generated from field: repeated billing.v3.PortalDiscount discounts = 3;
   */
  discounts: PortalDiscount[];
};

/**
 * Describes the message billing.v3.PortalSubscriptionUpdateConfirm.
 * Use `create(PortalSubscriptionUpdateConfirmSchema)` to create a new message.
 */
export const PortalSubscriptionUpdateConfirmSchema: GenMessage<PortalSubscriptionUpdateConfirm> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 6);

/**
 * PortalFlowData configures specific flows and actions available in the customer portal.
 * This allows you to customize what customers can do in the portal and guide them
 * through specific workflows like subscription changes or cancellations.
 *
 * @generated from message billing.v3.PortalFlowData
 */
export type PortalFlowData = Message<"billing.v3.PortalFlowData"> & {
  /**
   * Type specifies the type of flow to initiate in the portal
   *
   * @generated from field: billing.v3.PortalFlowType type = 1;
   */
  type: PortalFlowType;

  /**
   * AfterCompletion configures what happens after the customer completes the flow
   *
   * @generated from field: optional billing.v3.PortalAfterCompletion after_completion = 2;
   */
  afterCompletion: PortalAfterCompletion;

  /**
   * SubscriptionCancel configures subscription cancellation flows
   *
   * @generated from field: optional billing.v3.PortalSubscriptionCancel subscription_cancel = 3;
   */
  subscriptionCancel: PortalSubscriptionCancel;

  /**
   * SubscriptionUpdate configures subscription update flows
   *
   * @generated from field: optional billing.v3.PortalSubscriptionUpdate subscription_update = 4;
   */
  subscriptionUpdate: PortalSubscriptionUpdate;

  /**
   * SubscriptionUpdateConfirm configures subscription update confirmation flows
   *
   * @generated from field: optional billing.v3.PortalSubscriptionUpdateConfirm subscription_update_confirm = 5;
   */
  subscriptionUpdateConfirm: PortalSubscriptionUpdateConfirm;
};

/**
 * Describes the message billing.v3.PortalFlowData.
 * Use `create(PortalFlowDataSchema)` to create a new message.
 */
export const PortalFlowDataSchema: GenMessage<PortalFlowData> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 7);

/**
 * PortalSession represents a customer portal session.
 * This contains the information needed for customers to access their billing portal
 * where they can manage subscriptions, payment methods, and billing information.
 * Note: Portal sessions are ephemeral and not persisted in the database.
 *
 * @generated from message billing.v3.PortalSession
 */
export type PortalSession = Message<"billing.v3.PortalSession"> & {
  /**
   * ID is the unique identifier for this portal session (provider-generated)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * CustomerID is the billing customer this session belongs to
   *
   * @generated from field: string customer_id = 2;
   */
  customerId: string;

  /**
   * URL is the portal URL where the customer can manage their billing
   *
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * ReturnURL is where customers will be redirected when they leave the portal
   *
   * @generated from field: string return_url = 4;
   */
  returnUrl: string;

  /**
   * ExpiresAt is when this portal session expires and can no longer be used
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt: Timestamp;

  /**
   * CreatedAt is when this portal session was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt: Timestamp;

  /**
   * ProviderName is the payment provider that created this session
   *
   * @generated from field: string provider_name = 7;
   */
  providerName: string;

  /**
   * ProviderID is the provider-specific session ID
   *
   * @generated from field: string provider_id = 8;
   */
  providerId: string;

  /**
   * FlowData configures specific flows within the portal (optional)
   *
   * @generated from field: optional billing.v3.PortalFlowData flow_data = 9;
   */
  flowData: PortalFlowData;

  /**
   * Metadata contains custom key-value pairs for this session
   *
   * @generated from field: map<string, string> metadata = 10;
   */
  metadata: { [key: string]: string };

  /**
   * TenantID is the ID of the tenant this portal session belongs to
   *
   * @generated from field: string tenant_id = 11;
   */
  tenantId: string;

  /**
   * OrganizationID is the ID of the organization this portal session belongs to
   *
   * @generated from field: string organization_id = 12;
   */
  organizationId: string;
};

/**
 * Describes the message billing.v3.PortalSession.
 * Use `create(PortalSessionSchema)` to create a new message.
 */
export const PortalSessionSchema: GenMessage<PortalSession> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 8);

/**
 * CreatePortalSessionRequest contains parameters for creating a customer portal session.
 * The customer portal allows customers to manage their billing information, subscriptions,
 * and payment methods through a hosted interface provided by the payment processor.
 *
 * @generated from message billing.v3.CreatePortalSessionRequest
 */
export type CreatePortalSessionRequest = Message<"billing.v3.CreatePortalSessionRequest"> & {
  /**
   * CustomerID is the ID of the customer to create the portal session for
   *
   * @generated from field: string customer_id = 1;
   */
  customerId: string;

  /**
   * ReturnURL is where customers are redirected when they leave the portal
   *
   * @generated from field: string return_url = 2;
   */
  returnUrl: string;

  /**
   * ConfigurationID is the ID of a portal configuration to customize the portal experience
   *
   * @generated from field: optional string configuration_id = 3;
   */
  configurationId: string;

  /**
   * FlowData configures specific flows within the portal (optional)
   *
   * @generated from field: optional billing.v3.PortalFlowData flow_data = 4;
   */
  flowData: PortalFlowData;

  /**
   * TenantID is the ID of the tenant this portal session belongs to
   *
   * @generated from field: string tenant_id = 5;
   */
  tenantId: string;

  /**
   * OrganizationID is the ID of the organization this portal session belongs to
   *
   * @generated from field: string organization_id = 6;
   */
  organizationId: string;

  /**
   * Metadata contains custom key-value pairs for this session
   *
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message billing.v3.CreatePortalSessionRequest.
 * Use `create(CreatePortalSessionRequestSchema)` to create a new message.
 */
export const CreatePortalSessionRequestSchema: GenMessage<CreatePortalSessionRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 9);

/**
 * CreatePortalSessionResponse contains the result of creating a customer portal session.
 *
 * @generated from message billing.v3.CreatePortalSessionResponse
 */
export type CreatePortalSessionResponse = Message<"billing.v3.CreatePortalSessionResponse"> & {
  /**
   * Session is the created portal session
   *
   * @generated from field: billing.v3.PortalSession session = 1;
   */
  session: PortalSession;
};

/**
 * Describes the message billing.v3.CreatePortalSessionResponse.
 * Use `create(CreatePortalSessionResponseSchema)` to create a new message.
 */
export const CreatePortalSessionResponseSchema: GenMessage<CreatePortalSessionResponse> = /*@__PURE__*/
  messageDesc(file_billing_v3_portal, 10);

/**
 * PortalFlowType represents the type of flow to initiate in the customer portal.
 * This allows customization of what customers can do in the portal.
 *
 * @generated from enum billing.v3.PortalFlowType
 */
export enum PortalFlowType {
  /**
   * @generated from enum value: PORTAL_FLOW_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Payment flow for updating payment methods
   *
   * @generated from enum value: PORTAL_FLOW_TYPE_PAYMENT_METHOD_UPDATE = 1;
   */
  PAYMENT_METHOD_UPDATE = 1,

  /**
   * Subscription cancellation flow
   *
   * @generated from enum value: PORTAL_FLOW_TYPE_SUBSCRIPTION_CANCEL = 2;
   */
  SUBSCRIPTION_CANCEL = 2,

  /**
   * Subscription update flow
   *
   * @generated from enum value: PORTAL_FLOW_TYPE_SUBSCRIPTION_UPDATE = 3;
   */
  SUBSCRIPTION_UPDATE = 3,

  /**
   * Subscription update confirmation flow
   *
   * @generated from enum value: PORTAL_FLOW_TYPE_SUBSCRIPTION_UPDATE_CONFIRM = 4;
   */
  SUBSCRIPTION_UPDATE_CONFIRM = 4,
}

/**
 * Describes the enum billing.v3.PortalFlowType.
 */
export const PortalFlowTypeSchema: GenEnum<PortalFlowType> = /*@__PURE__*/
  enumDesc(file_billing_v3_portal, 0);

/**
 * PortalAfterCompletionType represents the action to take after a customer
 * completes a specific flow in the portal.
 *
 * @generated from enum billing.v3.PortalAfterCompletionType
 */
export enum PortalAfterCompletionType {
  /**
   * @generated from enum value: PORTAL_AFTER_COMPLETION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Redirect the customer to a specific URL
   *
   * @generated from enum value: PORTAL_AFTER_COMPLETION_TYPE_REDIRECT = 1;
   */
  REDIRECT = 1,

  /**
   * Show a hosted completion page
   *
   * @generated from enum value: PORTAL_AFTER_COMPLETION_TYPE_HOSTED = 2;
   */
  HOSTED = 2,
}

/**
 * Describes the enum billing.v3.PortalAfterCompletionType.
 */
export const PortalAfterCompletionTypeSchema: GenEnum<PortalAfterCompletionType> = /*@__PURE__*/
  enumDesc(file_billing_v3_portal, 1);

